/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Extensionplaceholder1Inputs */

const id_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstensi, misalnya pak`)
};

const ms_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sambungan, cth. pak`)
};

const da_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtypenavn, f.eks. pak`)
};

const de_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterung, z. B. pak`)
};

const en_us2_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension, e.g. pak`)
};

const es_es2_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensión, p. ej. pak`)
};

const es_mx2_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensión, p. ej. pak`)
};

const fil_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension, hal. pak`)
};

const fr_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension, par ex. pak`)
};

const it_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estensione, ad es. pak`)
};

const hu_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiterjesztés, például pak`)
};

const nl_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensie, bijv. pak`)
};

const no_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtype, f.eks. pak`)
};

const pl_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozszerzenie, np. pak`)
};

const pt_br2_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensão, ex.: pak`)
};

const pt_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensão, por exemplo pak`)
};

const ro_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensie, de ex. pak`)
};

const fi_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedostopääte, esim. pak`)
};

const sv_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filändelse, t.ex. pak`)
};

const vi_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phần mở rộng, ví dụ pak`)
};

const tr_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzantı, ör. pak`)
};

const cs_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přípona, např. pak`)
};

const bg_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разширение, напр. pak`)
};

const ru_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширение, например: pak`)
};

const uk_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розширення, наприклад pak`)
};

const ar_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الامتداد، مثل pak`)
};

const hi_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सटेंशन, जैसे pak`)
};

const th_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นามสกุล เช่น pak`)
};

const ja_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡張子（例: pak）`)
};

const zh_cn2_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扩展名，例如 pak`)
};

const zh_hant1_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`副檔名，例如 pak`)
};

const ko_builds_comparison_extensionplaceholder1 = /** @type {(inputs: Builds_Comparison_Extensionplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확장자(예: pak)`)
};

/**
* | output |
* | --- |
* | "Extension, e.g. pak" |
*
* @param {Builds_Comparison_Extensionplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_extensionplaceholder1 = /** @type {((inputs?: Builds_Comparison_Extensionplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Extensionplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "ms") return ms_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "da") return da_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "de") return de_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "fil") return fil_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "fr") return fr_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "it") return it_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "hu") return hu_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "nl") return nl_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "no") return no_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "pl") return pl_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "pt") return pt_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "ro") return ro_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "fi") return fi_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "sv") return sv_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "vi") return vi_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "tr") return tr_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "cs") return cs_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "bg") return bg_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "ru") return ru_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "uk") return uk_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "ar") return ar_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "hi") return hi_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "th") return th_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "ja") return ja_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_extensionplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_extensionplaceholder1(inputs)
	return ko_builds_comparison_extensionplaceholder1(inputs)
});
export { builds_comparison_extensionplaceholder1 as "builds.comparison.extensionPlaceholder" }